import { Container } from '@chakra-ui/react'

export default ({ children }) => {
  return (
    <Container py={4}>
      {children}
    </Container>
  )
}
